/*
 * IdleWatch
 * -------------------------------------------
 * Simple module which watches for user-input
 * (i.e, mouse click, keyboard, scroll). After
 * a set period of inactivity, a callback
 * function is called.
 * 
 * @author Shafique Arnab <shafique@buncee.com>
 */

define('shared/idlewatch',["jquery"], function ($) 
{
	var IdleWatch = function IdleWatch(config)
	{
		this.intervalID = null;
		this.idleDuration = 0;
		this.context = config["context"] || window;
		this.maxIdleTime = config["maxIdleTime"] || 3600;
		this.frequency = config["frequency"] || 10;
		this.onTimeout = (typeof config["onTimeout"] == "function") ? config["onTimeout"] : function ()
		{
			this.stopTimer();
			console.log("Maximum idle time has been reached!");
		}

		if (typeof config["autoStart"] == "boolean" && config["autoStart"] === true) {
			this.startTimer();
		}
	}

	IdleWatch.prototype.startTimer = function ()
	{
		var self = this;

		var intervalFunc = function ()
		{
			self.idleDuration += self.frequency;
			if (self.idleDuration >= self.maxIdleTime) {
				self.stopTimer();
				self.onTimeout();
			}
		}

		this.idleDuration = 0;
		this.intervalID = setInterval(intervalFunc, (this.frequency * 1000));
		
		$(this.context).on("mousemove.IdleWatch keydown.IdleWatch", function ()
		{
			self.idleDuration = 0;
		});
	}

	IdleWatch.prototype.stopTimer = function ()
	{
		clearInterval(this.intervalID);
		this.idleDuration = 0;
		this.intervalID = null;
		$(this.context).off("mousemove.IdleWatch keydown.IdleWatch");
	}

	return IdleWatch;
});
